/**
 * Specialties Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    specialties: [],
    specialty: {}
};

// Getters
const getters = {
    specialties: state => {
        return state.specialties
    },

    specialty: state => {
        return state.specialty
    }
};

// Actions
const actions = {
    getSpecialties(context, payload) {
        function successCallback(response) {
            context.commit('getSpecialtiesHandler', { specialties: response.data.specialites });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Specialty.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getSpecialty(context, payload) {
        function successCallback(response) {
            context.commit('getSpecialtyHandler', { specialty: response.data.specialite });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Specialty.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createSpecialty(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'specialty', params: { specialty: response.data.specialite.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Specialty.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateSpecialty(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'specialty' });

            router.push({ name: 'specialty', params: { specialty: response.data.specialite.slug } });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Specialty.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteSpecialty(context, payload) {
        function successCallback(response) {
            context.commit('deleteSpecialtyHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Specialty.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getSpecialtiesHandler(state, { specialties }) {
        // Update specialties state
        state.specialties = specialties;
    },

    getSpecialtyHandler(state, { specialty }) {
        // Update specialty state
        state.specialty = specialty;
    },

    deleteSpecialtyHandler(state, { index, successMessage }) {
        let i = state.specialties.findIndex(specialty => specialty.slug === index);

        if (~i) {
            state.specialties.splice(i, 1);

            router.push({ name: 'specialties' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
